import { SortDirectionCssClasses } from 'Angular/utils/sort/interfaces/sort-direction-css-classes.interface';
import { IndicesDataColumnInfo } from 'IndicesApp/ts/interfaces/indices-view-responses.interface';

export function getColumnHeaderClass(
    sortDirectionCssClasses: SortDirectionCssClasses,
    calc: IndicesDataColumnInfo
): string {
    let headerClass = '';
    const sortClass = sortDirectionCssClasses[calc.metricInternalName];
    if (sortClass && sortClass['th-sort-asc']) {
        headerClass += 'th-sort-asc ';
    } else if (sortClass && sortClass['th-sort-desc']) {
        headerClass += 'th-sort-desc ';
    }

    if (calc.headerClass === undefined) {
        headerClass += 'text-right';
    } else {
        headerClass += calc.headerClass;
    }
    return headerClass;
}
